export default {
	methods: {
		_onRowContextMenu({ event, popover }) {
			if (this.$scopedSlots['contextMenu']) {
				popover.open({ top: event.clientY, left: event.clientX });
				event.preventDefault();
			}
		}
	}
};